__turbopack_context__.v({
  "content": "GatewaySettingsDialog-module-scss-module__ID2l-a__content",
  "description": "GatewaySettingsDialog-module-scss-module__ID2l-a__description",
  "dialog": "GatewaySettingsDialog-module-scss-module__ID2l-a__dialog",
  "fieldBlock": "GatewaySettingsDialog-module-scss-module__ID2l-a__fieldBlock",
  "footer": "GatewaySettingsDialog-module-scss-module__ID2l-a__footer",
  "footerActions": "GatewaySettingsDialog-module-scss-module__ID2l-a__footerActions",
  "footerReset": "GatewaySettingsDialog-module-scss-module__ID2l-a__footerReset",
  "header": "GatewaySettingsDialog-module-scss-module__ID2l-a__header",
  "portsGrid": "GatewaySettingsDialog-module-scss-module__ID2l-a__portsGrid",
  "resetButton": "GatewaySettingsDialog-module-scss-module__ID2l-a__resetButton",
  "root": "GatewaySettingsDialog-module-scss-module__ID2l-a__root",
});
